import {updateCheckboxSettingState} from "../../settings/settings_common";
import {maybeShowGCalHelp} from "../../settings/gcal_help_modal";

let tokenClient = null;
let accessToken = null;

function initializeDayColumns() {
    let calendarHeight = document.getElementById("calendar").clientHeight;
    // initialize event day column elements
    let d1 = document.getElementById("row_start");
    for (let i = 0; i < 3; i++) {
        if (d1) {
            let day_name = document.createElement("div");
            day_name.classList.add("pt-4", "text-lg", "ltr:ml-4", "rtl:mr-4");
            day_name.textContent = document.querySelectorAll(".weather-card__date")[i].textContent;
            d1.append(day_name);
            d1.classList.add("calendar__eventday");
            d1.style.height = `${calendarHeight}px`;
            d1 = d1.nextElementSibling;
        }
    }
}

function clearCalendarEventsView() {
    document.querySelectorAll(`#calendar > div .event-dots`).forEach(el => {
        el.innerHTML = "";
    });
    // clean event day column elements
    let d1 = document.getElementById("row_start");
    for (let i = 0; i < 3; i++) {
        if (d1) {
            d1.className = "";
            d1.innerHTML = "";
            d1 = d1.nextElementSibling;
        }
    }
}

function loadGoogleIdentityServices() {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
}

export async function applyGoogleCalendar() {
    const gCalCheckBox = document.querySelector("#gcal_sync_form input");
    updateCheckboxSettingState(gCalCheckBox);
    clearCalendarEventsView();

    if (gCalCheckBox.checked) {
        await initGoogleCalendar();
        initializeDayColumns();
        maybeShowGCalHelp();
    }
}


async function initGoogleCalendar() {
    if (tokenClient !== null) {
        clarity("set", "gcal", "enable");
        tokenClient.requestAccessToken();
    } else {
        await loadGoogleIdentityServices(); // Ensure the Google Identity Services script is loaded
        tokenClient = google.accounts.oauth2.initTokenClient({
            client_id: '40669866937-ihc4oc3n7mgb93dqo7ten8sv833uv6q4.apps.googleusercontent.com',
            scope: 'https://www.googleapis.com/auth/calendar.readonly',
            callback: async (resp) => {
                if (resp.error !== undefined) {
                    throw (resp);
                }
                accessToken = resp.access_token;
                await fetchCalendarEvents();
            },
            prompt: ''
        });
        tokenClient.requestAccessToken();
    }
}

async function fetchCalendarEvents() {
    clarity("set", "gcal", "complete");
    const headers = new Headers({
        'Authorization': 'Bearer ' + accessToken,
        'Content-Type': 'application/json'
    });
    console.log("Fetching google events");

    // Calculate the date 5 days from now
    let fiveDaysFromNow = new Date();
    fiveDaysFromNow.setDate(fiveDaysFromNow.getDate() + 5);

    // Calculate the end of the current month
    let endOfMonth = new Date();
    endOfMonth.setMonth(endOfMonth.getMonth() + 1, 0); // Set to the last day of the current month

    // Use the latter of the two dates as timeMax
    let timeMin = new Date();
    timeMin.setHours(0, 0, 0, 0);
    let timeMax = fiveDaysFromNow > endOfMonth ? fiveDaysFromNow : endOfMonth;
    console.log("Fetching calendar colors");
    const colorResponse = await (await fetch("https://www.googleapis.com/calendar/v3/colors", {headers: headers})).json();
    const eventColors = colorResponse.event;

    let calendarColors = {};

    const calendarsResponse = await (await fetch("https://www.googleapis.com/calendar/v3/users/me/calendarList", {headers: headers})).json();
    const calendars = calendarsResponse.items;

    calendars.forEach(calendar => {
        if (calendar.primary) {
            calendarColors['primary'] = calendar.backgroundColor;
        }
        calendarColors[calendar.id] = calendar.backgroundColor;
    });
    console.log("Calendars: " + calendars);

    const params = new URLSearchParams({
        'timeMin': timeMin.toISOString(),
        'timeMax': timeMax.toISOString(),
        'showDeleted': false,
        'singleEvents': true,
        'maxResults': 100,
        'orderBy': 'startTime'
    }).toString();

    let response = await (await fetch(`https://www.googleapis.com/calendar/v3/calendars/primary/events?${params}`, {headers: headers})).json();
    const events = response.items;
    document.querySelectorAll(`#calendar .event-dots`).forEach(p => {
        p.innerHTML = "";
    });

    events.forEach(event => {
        // Extracting start and end dates and times
        const startDate = event.start.date || event.start.dateTime;
        const endDate = event.end.date || event.end.dateTime;

        // Convert dates to more manageable formats
        const startDay = new Date(startDate).getDate();
        const endDay = new Date(endDate).getDate();

        // ignore day events
        if (!event.start.dateTime || !event.end.dateTime) {
            return;
        }

        // Extract times if they exist
        const startTime = new Date(event.start.dateTime).toTimeString().slice(0, 5);
        const endTime = new Date(event.end.dateTime).toTimeString().slice(0, 5);

        let eventColor;
        if (event.colorId && eventColors[event.colorId]) {
            eventColor = eventColors[event.colorId].background;
        } else {
            eventColor = calendarColors['primary'];
        }

        // Call addEventToDay for each day the event spans
        for (let day = startDay; day <= endDay; day++) {
            addEventToDay(day, startTime, endTime, eventColor);
        }
    });

    const CALENDAR_START_HOUR = 6;
    const ACTIVE_HOURS = 14;

    // Function to calculate duration in hours
    function calculateDuration(start, end) {
        const startDate = new Date(start);
        const endDate = new Date(end);
        return (endDate - startDate) / (1000 * 60 * 60);
    }

    // Function to calculate top offset based on event start time, considering the calendar starts at 8:00 AM
    function calculateTopOffset(startTime) {
        const eventStart = new Date(startTime);
        const offsetHours = Math.max(eventStart.getHours() + eventStart.getMinutes() / 60 - CALENDAR_START_HOUR, 0);
        return (offsetHours / ACTIVE_HOURS) * 100; // Convert to a percentage of the active hours
    }

    // Function to create an event element with dynamic height and top offset
    function createEventElement(event, startTime, endTime, eventColor) {
        let eventElement = document.createElement("div");
        eventElement.classList.add("calendar__event");
        let options = { hour: '2-digit', minute: '2-digit' };
        let eventTimeElement = document.createElement("div");
        eventTimeElement.innerText = `${new Date(startTime).toLocaleTimeString([], options)} – ${new Date(endTime).toLocaleTimeString([], options)}`
        eventTimeElement.classList.add("calendar__event-time");
        let eventTitleElement = document.createElement("div");
        eventTitleElement.innerText = event.summary;
        eventElement.appendChild(eventTimeElement);
        eventElement.appendChild(eventTitleElement);
        eventElement.style.backgroundColor = eventColor;

        const durationHours = calculateDuration(startTime, endTime);
        const heightPercent = (durationHours / ACTIVE_HOURS) * 100; // Calculate height as a percentage of active hours
        eventElement.style.minHeight = `${heightPercent}%`;
        eventElement.style.top = `${calculateTopOffset(startTime)}%`;

        return eventElement;
    }

    let today = new Date();
    let tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    let dayAfterTomorrow = new Date(today);
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);

    events.forEach(event => {
        const eventStart = new Date(event.start.dateTime || event.start.date);
        let eventElement;
        let eventColor = event.colorId && eventColors[event.colorId] ? eventColors[event.colorId].background : calendarColors['primary'] || '#cccccc';
        if (!event.start.dateTime || !event.end.dateTime) {
            return;
        }

        if (eventStart.toDateString() === today.toDateString()) {
            eventElement = createEventElement(event, event.start.dateTime, event.end.dateTime, eventColor);
            document.getElementById("row_start").appendChild(eventElement);
        } else if (eventStart.toDateString() === tomorrow.toDateString()) {
            eventElement = createEventElement(event, event.start.dateTime, event.end.dateTime, eventColor);
            document.getElementById("row_start").nextElementSibling.appendChild(eventElement);
        } else if (eventStart.toDateString() === dayAfterTomorrow.toDateString()) {
            eventElement = createEventElement(event, event.start.dateTime, event.end.dateTime, eventColor);
            document.getElementById("row_start").nextElementSibling.nextElementSibling.appendChild(eventElement);
        }
    });
}

function addEventToDay(day, startTime, endTime, color) {
    // Determine the time of day for the event and draw a dot accordingly
    const dotElem = document.querySelector(`#calendar div[data-day="${day}"] .event-dots`);
    if (dotElem.childElementCount === 0) {
        const numberOfDots = 3;
        for (let i = 0; i < numberOfDots; i++) {
            let dot = document.createElement("span");
            dot.className = "dot";
            dotElem.appendChild(dot);
        }
    }
    const startHour = Number(startTime.split(':')[0]);
    let positionIndex;

    if (startHour < 11) {
        // Morning
        positionIndex = 0;
    } else if (startHour >= 11 && startHour < 15) {
        // Midday
        positionIndex = 1;
    } else {
        // Evening
        positionIndex = 2;
    }
    const dots = dotElem.children;
    dots[positionIndex].style.backgroundColor = color;
    dots[positionIndex].style.opacity = 1;
}



